import * as u from '../utils';

export default () => {
    const controls = document.querySelectorAll('.single-product-menu__tab');
    const tabs = document.querySelectorAll('.single-product-details__tab');
    const shortDescToggle = document.querySelector('.woocommerce-product-details__tec-spec-link ');
    const header = document.querySelector('.header');
    const externalSupportTrigger = document.querySelector('a[href="#support"]');
    const downloadWindow = document.querySelector('.single-product-downloads');

    if (!controls.length) {
        return false;
    }

    const handleClick = (e) => {
        const trigger = e.currentTarget;
        const target = e.currentTarget.dataset.target;

        u.removeClass(controls, 'is-active');
        if (trigger.dataset.window) {
            u.addClass(
                document.querySelectorAll(
                    `.single-product-menu__tab[data-target="${target}"][data-window="${trigger.dataset.window}"]`
                ),
                'is-active'
            );
            if (downloadWindow) {
                u.boolClass(downloadWindow, 'is-active', trigger.dataset.window === 'downloads');
            }
        } else {
            u.addClass(
                document.querySelectorAll('.single-product-menu__tab[data-target="' + target + '"]'),
                'is-active'
            );
        }

        u.removeClass(tabs, 'is-active');
        u.addClass(document.querySelector(target), 'is-active');

        u.trigger('resize', window);

        if (window.pageYOffset > header.offsetHeight) {
            // TODO - Work out why this returns pageYOffset as 0/1 after running once
            window.scrollTo(0, header.offsetHeight);
        }
    };

    for (const el of controls) {
        el.addEventListener('click', handleClick);
    }

    if (shortDescToggle) {
        shortDescToggle.addEventListener('click', handleClick);
    }

    if (externalSupportTrigger) {
        externalSupportTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            u.trigger('click', document.querySelector('[data-target=".product-support"]'));
        });
    }
};
